import { gql } from "@apollo/client";

export const CREATE_STOCK = gql`
  mutation CreateStock($data: StockInput!) {
    createStock(data: $data) {
        id
    }
}
`;

export const CREATE_MANY_STOCKS = gql`
mutation CreateManayStocks($where: StockShopWhereInput!, $data: StocksInput) {
  createManayStocks(where: $where, data: $data) {
    message
  }
}
`;

export const UPDATE_STOCK = gql`
  mutation UpdateStock($data: StockInput!, $where: StockWhereInputOne!) {
    updateStock(data: $data, where: $where) {
        id
    }
}
`;
export const UPDATE_STOCK_V2 = gql`
  mutation UpdateStockV2($data: StockInput!, $where: StockWhereInputOne!) {
    updateStockV2(data: $data, where: $where) {
        id
    }
}
`;

export const CANCELLED_ORDER_GROUPS = gql`
  mutation CancelOrderGroups($where: OrderGroupWhereUpdateManyInput!) {
    cancelOrderGroups(where: $where)
  }
`;

export const UPDATE_STOCK_FOR_LIVE_ON_AIR = gql`
  mutation Mutation {
    updateStockForLiveOnAir
  }
`;

export const DELETED_STOCK = gql`
  mutation DeleteStock($where: StockWhereInputOne!) {
    deleteStock(where: $where) {
        id
    }
}
`;

export const UPDATE_MANY_STOCK = gql`
  mutation UpdateManyStock($data: StockInput!, $where: StockWhereInputMany!) {
    updateManyStock(data: $data, where: $where) {
        count
    }
}
`;